import { Call } from '../../../utils/multicall'
import { getLenderAssets } from '../../../utils'
import {
  getCompoundV3BaseAsset,
  getCompoundV3CometAddress,
  getCompoundV3CometRewardsAddress,
} from '../../public-data/addresses/compoundV3'
import { buildCometLensCall, usesCometLens } from './lens'

export const buildCompoundV3UserCall = (
  chainId: string,
  lender: string,
  account: string,
): Call[] => {
  const baseAsset = getCompoundV3BaseAsset(lender, chainId)?.baseAsset
  const cometContractAddress = getCompoundV3CometAddress(chainId, lender)!
  const assets = getLenderAssets(chainId, lender).sort((a, b) =>
    a.toLowerCase().localeCompare(b.toLowerCase()),
  )
  const assetsNoBase = assets.filter((a) => a !== baseAsset)

  const baseCalls = [
    {
      address: cometContractAddress,
      name: 'balanceOf',
      params: [account],
    },
    {
      address: cometContractAddress,
      name: 'borrowBalanceOf',
      params: [account],
    },
  ]

  const callsNonBase: Call[] = assetsNoBase.map((tk) => {
    return {
      address: cometContractAddress,
      name: 'userCollateral',
      params: [account, tk],
    }
  })

  const callEarnedBalances = {
    address: getCompoundV3CometRewardsAddress(chainId),
    name: 'getRewardOwed',
    params: [cometContractAddress, account],
  }
  // The lens answers the collateral loop AND both base legs in one call; the
  // rewards read lives on a different contract and stays separate. A chain with
  // no deployment keeps the walk — the rollout switch and the emergency revert.
  if (usesCometLens(chainId, lender)) {
    const lensCall = buildCometLensCall(
      chainId,
      cometContractAddress,
      assetsNoBase,
      account,
    )
    if (lensCall.length) return [...lensCall, callEarnedBalances]
  }

  const calls = [...callsNonBase, ...baseCalls, callEarnedBalances]
  return calls
}
